var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "integralEdit seller-style" },
    [
      _c("h2", { staticClass: "f18 fb normal gray_2" }, [
        _vm._v(
          _vm._s(_vm.ruleDtl.pointsType == 1 ? "发放规则设置" : "使用规则设置")
        )
      ]),
      _c("div", { staticClass: "box30" }),
      _vm.ruleDtl.pointsType == 1
        ? _c(
            "div",
            { staticClass: "flex mar30_b" },
            [
              _c("div", { staticClass: "pad30_lr label" }, [
                _vm._v("适用客户:")
              ]),
              _c(
                "el-radio-group",
                {
                  on: {
                    change: function($event) {
                      return _vm.getCustomerType()
                    }
                  },
                  model: {
                    value: _vm.ruleDtl.applyCustomerType,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleDtl, "applyCustomerType", $$v)
                    },
                    expression: "ruleDtl.applyCustomerType"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 3 } }, [
                    _c("span", [_vm._v("按指定客户")]),
                    _vm.ruleDtl.applyCustomerType === 3
                      ? _c(
                          "div",
                          { staticClass: "rule_clientType pad15_t" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "mar10_l",
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.openCustomerPop()
                                  }
                                }
                              },
                              [_vm._v("添加")]
                            ),
                            _c("div", { staticClass: "box20" }),
                            _c(
                              "el-table",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { data: _vm.customerPop.customerSelList }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "name",
                                    label: "客户名称",
                                    width: "300"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "phone",
                                    width: "260",
                                    label: "联系电话"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "groupName",
                                    label: "分组名称"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "操作" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "blue cursor",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeSelectCustomer(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("删除")]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    472571258
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _c("span", [_vm._v("按客户分组")]),
                    _vm.ruleDtl.applyCustomerType === 2
                      ? _c(
                          "div",
                          { staticClass: "mar30_l" },
                          [
                            _c(
                              "el-checkbox-group",
                              {
                                staticClass: "flex flex_wrap",
                                attrs: { size: "small" },
                                model: {
                                  value: _vm.ruleDtl.applyCustomerAttr,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.ruleDtl,
                                      "applyCustomerAttr",
                                      $$v
                                    )
                                  },
                                  expression: "ruleDtl.applyCustomerAttr"
                                }
                              },
                              _vm._l(_vm.customerPop.groupDataList, function(
                                group
                              ) {
                                return _c(
                                  "el-checkbox",
                                  {
                                    key: group.id,
                                    staticClass: "mar15_t",
                                    attrs: { label: group.id, border: "" }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(group.name) +
                                        "\n            "
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _c("span", [_vm._v("所有人群")])
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("div", { staticClass: "pad30_lr" }, [_vm._v("规则详情:")]),
          _c(
            "el-radio-group",
            {
              on: { change: _vm.busTypeChange },
              model: {
                value: _vm.ruleDtl.busType,
                callback: function($$v) {
                  _vm.$set(_vm.ruleDtl, "busType", $$v)
                },
                expression: "ruleDtl.busType"
              }
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.ruleDtl.pointsType == 1
                        ? "根据订单发放"
                        : "根据订单使用"
                    )
                  )
                ])
              ]),
              _c(
                "el-radio-group",
                {
                  staticClass: "mar30_l",
                  on: { change: _vm.ruleTypeChange },
                  model: {
                    value: _vm.ruleDtl.ruleType,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleDtl, "ruleType", $$v)
                    },
                    expression: "ruleDtl.ruleType"
                  }
                },
                [
                  _c(
                    "el-radio",
                    { attrs: { label: 2 } },
                    [
                      _c("span", [_vm._v("订单每满")]),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.ruleDtl.ruleType !== 2 ||
                            _vm.ruleDtl.busType !== 1
                        },
                        on: {
                          input: function($event) {
                            _vm.ruleDtl.ruleKey2 = _vm.formatNums(
                              _vm.ruleDtl.ruleKey2,
                              true
                            )
                          }
                        },
                        model: {
                          value: _vm.ruleDtl.ruleKey2,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleDtl, "ruleKey2", $$v)
                          },
                          expression: "ruleDtl.ruleKey2"
                        }
                      }),
                      _c("span", [
                        _vm._v(
                          "元，" +
                            _vm._s(
                              _vm.ruleDtl.pointsType == 1 ? "发放" : "可使用"
                            )
                        )
                      ]),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.ruleDtl.ruleType !== 2 ||
                            _vm.ruleDtl.busType !== 1
                        },
                        on: {
                          input: function($event) {
                            _vm.ruleDtl.ruleValue2 = _vm.formatNums(
                              _vm.ruleDtl.ruleValue2,
                              true
                            )
                          }
                        },
                        model: {
                          value: _vm.ruleDtl.ruleValue2,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleDtl, "ruleValue2", $$v)
                          },
                          expression: "ruleDtl.ruleValue2"
                        }
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.ruleDtl.name))])
                    ],
                    1
                  ),
                  _c(
                    "el-radio",
                    { attrs: { label: 3 } },
                    [
                      _c("span", [
                        _vm._v(
                          "每笔订单" +
                            _vm._s(
                              _vm.ruleDtl.pointsType == 1 ? "发放" : "使用"
                            ) +
                            "订单金额的"
                        )
                      ]),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.ruleDtl.ruleType !== 3 ||
                            _vm.ruleDtl.busType !== 1
                        },
                        on: {
                          input: function($event) {
                            _vm.ruleDtl.ruleValue3 = _vm.formatNums(
                              _vm.ruleDtl.ruleValue3,
                              true
                            )
                          }
                        },
                        model: {
                          value: _vm.ruleDtl.ruleValue3,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleDtl, "ruleValue3", $$v)
                          },
                          expression: "ruleDtl.ruleValue3"
                        }
                      }),
                      _c("span", [_vm._v("%")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.ruleDtl.pointsType == 1
                ? _c(
                    "el-radio",
                    { attrs: { label: 4 } },
                    [
                      _c("span", [_vm._v("根据评论发放 ")]),
                      _c("span", [_vm._v("每个好评评论字数达到")]),
                      _c("el-input", {
                        attrs: { disabled: _vm.ruleDtl.busType !== 4 },
                        on: {
                          input: function($event) {
                            _vm.ruleDtl.ruleKey4 = _vm.formatNums(
                              _vm.ruleDtl.ruleKey4,
                              true
                            )
                          }
                        },
                        model: {
                          value: _vm.ruleDtl.ruleKey4,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleDtl, "ruleKey4", $$v)
                          },
                          expression: "ruleDtl.ruleKey4"
                        }
                      }),
                      _c("span", [_vm._v("字，发放")]),
                      _c("el-input", {
                        attrs: { disabled: _vm.ruleDtl.busType !== 4 },
                        on: {
                          input: function($event) {
                            _vm.ruleDtl.ruleValue4 = _vm.formatNums(
                              _vm.ruleDtl.ruleValue4,
                              true
                            )
                          }
                        },
                        model: {
                          value: _vm.ruleDtl.ruleValue4,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleDtl, "ruleValue4", $$v)
                          },
                          expression: "ruleDtl.ruleValue4"
                        }
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.ruleDtl.name))])
                    ],
                    1
                  )
                : _vm._e(),
              _c("el-radio", { attrs: { label: 2 } }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.ruleDtl.pointsType == 1
                        ? "根据商品发放"
                        : "根据商品使用"
                    )
                  )
                ]),
                _vm.ruleDtl.busType === 2
                  ? _c(
                      "div",
                      { staticClass: "mar30_l mar15-t rule_goodType" },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.ruleDtl.goodRuleType,
                              callback: function($$v) {
                                _vm.$set(_vm.ruleDtl, "goodRuleType", $$v)
                              },
                              expression: "ruleDtl.goodRuleType"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { label: 1 } },
                              [
                                _c("span", [_vm._v("每种商品成功交易")]),
                                _c("el-input", {
                                  attrs: {
                                    disabled:
                                      _vm.ruleDtl.goodRuleType !== 1 ||
                                      _vm.ruleDtl.busType !== 2
                                  },
                                  on: {
                                    input: function($event) {
                                      _vm.ruleDtl.goodRuleKey1 = _vm.formatNums(
                                        _vm.ruleDtl.goodRuleKey1,
                                        true
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.ruleDtl.goodRuleKey1,
                                    callback: function($$v) {
                                      _vm.$set(_vm.ruleDtl, "goodRuleKey1", $$v)
                                    },
                                    expression: "ruleDtl.goodRuleKey1"
                                  }
                                }),
                                _c("span", [
                                  _vm._v(
                                    "件，" +
                                      _vm._s(
                                        _vm.ruleDtl.pointsType == 1
                                          ? "发放"
                                          : "使用"
                                      )
                                  )
                                ]),
                                _c("el-input", {
                                  attrs: {
                                    disabled:
                                      _vm.ruleDtl.goodRuleType !== 1 ||
                                      _vm.ruleDtl.busType !== 2
                                  },
                                  on: {
                                    input: function($event) {
                                      _vm.ruleDtl.goodRuleValue1 = _vm.formatNums(
                                        _vm.ruleDtl.goodRuleValue1,
                                        true
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.ruleDtl.goodRuleValue1,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.ruleDtl,
                                        "goodRuleValue1",
                                        $$v
                                      )
                                    },
                                    expression: "ruleDtl.goodRuleValue1"
                                  }
                                }),
                                _c("span", [_vm._v(_vm._s(_vm.ruleDtl.name))])
                              ],
                              1
                            ),
                            _c(
                              "el-radio",
                              { attrs: { label: 2 } },
                              [
                                _c("span", [_vm._v("每种商品每成功交易")]),
                                _c("el-input", {
                                  attrs: {
                                    disabled:
                                      _vm.ruleDtl.goodRuleType !== 2 ||
                                      _vm.ruleDtl.busType !== 2
                                  },
                                  on: {
                                    input: function($event) {
                                      _vm.ruleDtl.goodRuleKey2 = _vm.formatNums(
                                        _vm.ruleDtl.goodRuleKey2,
                                        true
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.ruleDtl.goodRuleKey2,
                                    callback: function($$v) {
                                      _vm.$set(_vm.ruleDtl, "goodRuleKey2", $$v)
                                    },
                                    expression: "ruleDtl.goodRuleKey2"
                                  }
                                }),
                                _c("span", [
                                  _vm._v(
                                    "元，" +
                                      _vm._s(
                                        _vm.ruleDtl.pointsType == 1
                                          ? "发放"
                                          : "使用"
                                      )
                                  )
                                ]),
                                _c("el-input", {
                                  attrs: {
                                    disabled:
                                      _vm.ruleDtl.goodRuleType !== 2 ||
                                      _vm.ruleDtl.busType !== 2
                                  },
                                  on: {
                                    input: function($event) {
                                      _vm.ruleDtl.goodRuleValue2 = _vm.formatNums(
                                        _vm.ruleDtl.goodRuleValue2,
                                        true
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.ruleDtl.goodRuleValue2,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.ruleDtl,
                                        "goodRuleValue2",
                                        $$v
                                      )
                                    },
                                    expression: "ruleDtl.goodRuleValue2"
                                  }
                                }),
                                _c("span", [_vm._v(_vm._s(_vm.ruleDtl.name))])
                              ],
                              1
                            ),
                            _c(
                              "el-radio",
                              { attrs: { label: 3 } },
                              [
                                _c("span", [
                                  _vm._v(
                                    "每件商品，" +
                                      _vm._s(
                                        _vm.ruleDtl.pointsType == 1
                                          ? "发放"
                                          : "使用"
                                      ) +
                                      "订单中该商品金额的"
                                  )
                                ]),
                                _c("el-input", {
                                  attrs: {
                                    disabled:
                                      _vm.ruleDtl.goodRuleType !== 3 ||
                                      _vm.ruleDtl.busType !== 2
                                  },
                                  on: {
                                    input: function($event) {
                                      _vm.ruleDtl.goodRuleValue3 = _vm.formatNums(
                                        _vm.ruleDtl.goodRuleValue3,
                                        true
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.ruleDtl.goodRuleValue3,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.ruleDtl,
                                        "goodRuleValue3",
                                        $$v
                                      )
                                    },
                                    expression: "ruleDtl.goodRuleValue3"
                                  }
                                }),
                                _c("span", [_vm._v("%")])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "add_good" },
                          [
                            _c("p", { staticClass: "gray6" }, [
                              _vm._v("添加货品")
                            ]),
                            _c("div", { staticClass: "box10" }),
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.ruleDtl.goodType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ruleDtl, "goodType", $$v)
                                  },
                                  expression: "ruleDtl.goodType"
                                }
                              },
                              [
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _c("span", [_vm._v("全部商品")])
                                ]),
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _c("span", [_vm._v("指定商品")])
                                ])
                              ],
                              1
                            ),
                            _vm.ruleDtl.goodType === 2
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "mar10_l",
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectGoodsList("shop")
                                          }
                                        }
                                      },
                                      [_vm._v("添加商品")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "mar10_l",
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectGoodsList("dealer")
                                          }
                                        }
                                      },
                                      [_vm._v("添加代销商品")]
                                    ),
                                    _c("div", { staticClass: "box20" }),
                                    _c(
                                      "el-table",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: { data: _vm.checkGoodsList }
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "name",
                                            label: "商品名称",
                                            width: "300"
                                          }
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "marketPriceStr",
                                            width: "260",
                                            label: "价格"
                                          }
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "statusName",
                                            label: "状态"
                                          }
                                        }),
                                        _c("el-table-column", {
                                          attrs: { label: "操作" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(scope) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "blue cursor",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.removeCheckGoods(
                                                              scope.row.goodsId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("删除")]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            905970771
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm.ruleDtl.pointsType == 1
                ? _c("el-radio", { attrs: { label: 5 } }, [
                    _c("span", [_vm._v("累计发放")]),
                    _c("span", { staticClass: "f12 gray9 mar30_l" }, [
                      _vm._v(
                        "按照用户符合条件的最高消费金额或最多商品件数进行发放"
                      )
                    ]),
                    _vm.ruleDtl.busType === 5
                      ? _c(
                          "div",
                          {
                            staticClass: "mar30_l mar15-t gray6 rule_goodType"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "mar15_b" },
                              [
                                _c("span", { staticClass: "pad20_r" }, [
                                  _vm._v("时间范围：")
                                ]),
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    "popper-class": "seller-style",
                                    "default-time": ["00:00:00", "23:59:59"]
                                  },
                                  model: {
                                    value: _vm.ruleDtl.timeStr,
                                    callback: function($$v) {
                                      _vm.$set(_vm.ruleDtl, "timeStr", $$v)
                                    },
                                    expression: "ruleDtl.timeStr"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.ruleDtl.sbusType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ruleDtl, "sbusType", $$v)
                                  },
                                  expression: "ruleDtl.sbusType"
                                }
                              },
                              [
                                _c(
                                  "el-radio",
                                  { attrs: { label: 1 } },
                                  [
                                    _c("span", [_vm._v("按消费金额发放")]),
                                    _vm.ruleDtl.sbusType === 1
                                      ? _vm._l(
                                          _vm.ruleDtl.subRuleAttrVal,
                                          function(item, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass:
                                                  "mar30_l mar10_t gray6"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "所选时间范围内累计消费满"
                                                  )
                                                ]),
                                                _c("el-input", {
                                                  model: {
                                                    value: item.ruleKey,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "ruleKey",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.ruleKey"
                                                  }
                                                }),
                                                _c("span", [
                                                  _vm._v("元，发放")
                                                ]),
                                                _c("el-input", {
                                                  model: {
                                                    value: item.ruleValue,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "ruleValue",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.ruleValue"
                                                  }
                                                }),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(_vm.ruleDtl.name)
                                                  )
                                                ]),
                                                _vm.ruleDtl.subRuleAttrVal
                                                  .length !==
                                                index + 1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "mar30_l blue",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.delsubRuleAttrVal(
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("删除")]
                                                    )
                                                  : _vm._e(),
                                                _vm.ruleDtl.subRuleAttrVal
                                                  .length ===
                                                index + 1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "mar30_l c_nx_blue",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.addsubRuleAttrVal()
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("添加")]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          }
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                ),
                                _c(
                                  "el-radio",
                                  { attrs: { label: 2 } },
                                  [
                                    _c("span", [_vm._v("按商品发放")]),
                                    _vm.ruleDtl.sbusType === 2
                                      ? _vm._l(
                                          _vm.ruleDtl.subRuleAttrVal,
                                          function(item, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass:
                                                  "mar30_l mar10_t gray6"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "所选时间范围内商品成功交易"
                                                  )
                                                ]),
                                                _c("el-input", {
                                                  model: {
                                                    value: item.ruleKey,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "ruleKey",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.ruleKey"
                                                  }
                                                }),
                                                _c("span", [
                                                  _vm._v("件，发放")
                                                ]),
                                                _c("el-input", {
                                                  model: {
                                                    value: item.ruleValue,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "ruleValue",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.ruleValue"
                                                  }
                                                }),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(_vm.ruleDtl.name)
                                                  )
                                                ]),
                                                _vm.ruleDtl.subRuleAttrVal
                                                  .length !==
                                                index + 1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "mar30_l blue",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.delsubRuleAttrVal(
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("删除")]
                                                    )
                                                  : _vm._e(),
                                                _vm.ruleDtl.subRuleAttrVal
                                                  .length ===
                                                index + 1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "mar30_l c_nx_blue",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.addsubRuleAttrVal()
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("添加")]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          }
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "add_good" },
                              [
                                _c("p", { staticClass: "gray6" }, [
                                  _vm._v("添加货品")
                                ]),
                                _c("div", { staticClass: "box10" }),
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.ruleDtl.goodType,
                                      callback: function($$v) {
                                        _vm.$set(_vm.ruleDtl, "goodType", $$v)
                                      },
                                      expression: "ruleDtl.goodType"
                                    }
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _c("span", [_vm._v("全部商品")])
                                    ]),
                                    _c("el-radio", { attrs: { label: 2 } }, [
                                      _c("span", [_vm._v("指定商品")])
                                    ])
                                  ],
                                  1
                                ),
                                _vm.ruleDtl.goodType === 2
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "mar10_l",
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function($event) {
                                                return _vm.selectGoodsList(
                                                  "shop"
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("添加商品")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "mar10_l",
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function($event) {
                                                return _vm.selectGoodsList(
                                                  "dealer"
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("添加代销商品")]
                                        ),
                                        _c("div", { staticClass: "box20" }),
                                        _c(
                                          "el-table",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: { data: _vm.checkGoodsList }
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "name",
                                                label: "商品名称",
                                                width: "300"
                                              }
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "marketPriceStr",
                                                width: "260",
                                                label: "价格"
                                              }
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "statusName",
                                                label: "状态"
                                              }
                                            }),
                                            _c("el-table-column", {
                                              attrs: { label: "操作" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "blue cursor",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.removeCheckGoods(
                                                                  scope.row
                                                                    .goodsId
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("删除")]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                905970771
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm.ruleDtl.pointsType == 1 &&
              _vm.ruleDtl.shopId == "6340867391440003296"
                ? _c("el-radio", { attrs: { label: 6 } }, [
                    _c("span", [_vm._v("社区激励")]),
                    _vm.ruleDtl.busType === 6
                      ? _c("div", { staticClass: "pad40-l gray3" }, [
                          _c(
                            "div",
                            { staticClass: "mar15_b pad10-t" },
                            [
                              _c("span", { staticClass: "pad20_r" }, [
                                _vm._v("时间范围：")
                              ]),
                              _c("el-date-picker", {
                                attrs: {
                                  type: "daterange",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  "default-time": ["00:00:00", "23:59:59"]
                                },
                                model: {
                                  value: _vm.ruleDtl.timeStr,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ruleDtl, "timeStr", $$v)
                                  },
                                  expression: "ruleDtl.timeStr"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "pad10-t" },
                            [
                              _c("span", [_vm._v("发帖")]),
                              _c("span", { staticClass: "f12 gray9 mar30_l" }, [
                                _vm._v("帖子审核通过后，发帖者可得积分")
                              ]),
                              _vm._l(_vm.ruleDtl.subRuleAttrList, function(
                                subRuleAttr
                              ) {
                                return _c(
                                  "div",
                                  { key: subRuleAttr.ruleSubType },
                                  [
                                    subRuleAttr.ruleSubType === "FT_BY_OPERATOR"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "pad20-l gray3 pad10-t"
                                          },
                                          [
                                            _c("span", [_vm._v("发帖者获得")]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.pointsGrantValue = _vm.formatNums(
                                                    subRuleAttr.pointsGrantValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.pointsGrantValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "pointsGrantValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.pointsGrantValue"
                                              }
                                            }),
                                            _c("span", [
                                              _vm._v("积分，每日奖励上限")
                                            ]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.ruleSubHandleLimitValue = _vm.formatNums(
                                                    subRuleAttr.ruleSubHandleLimitValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.ruleSubHandleLimitValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "ruleSubHandleLimitValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.ruleSubHandleLimitValue"
                                              }
                                            }),
                                            _c("span", [
                                              _vm._v("条数，每日奖励上限")
                                            ]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.pointsGrantLimitValue = _vm.formatNums(
                                                    subRuleAttr.pointsGrantLimitValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.pointsGrantLimitValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "pointsGrantLimitValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.pointsGrantLimitValue"
                                              }
                                            }),
                                            _c("span", [_vm._v("积分")])
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "pad10-t" },
                            [
                              _c("span", [_vm._v("关注")]),
                              _c("span", { staticClass: "f12 gray9 mar30_l" }, [
                                _vm._v(
                                  "关注对单一被关注者不论关注多少次，积分只能领取一次"
                                )
                              ]),
                              _vm._l(_vm.ruleDtl.subRuleAttrList, function(
                                subRuleAttr
                              ) {
                                return _c(
                                  "div",
                                  { key: subRuleAttr.ruleSubType },
                                  [
                                    subRuleAttr.ruleSubType === "GZ_BY_OPERATOR"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "pad10-t pad20-l gray3"
                                          },
                                          [
                                            _c("span", [
                                              _vm._v("被关注者获得")
                                            ]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.pointsGrantValue = _vm.formatNums(
                                                    subRuleAttr.pointsGrantValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.pointsGrantValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "pointsGrantValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.pointsGrantValue"
                                              }
                                            }),
                                            _c("span", [
                                              _vm._v("积分，每日奖励上限")
                                            ]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.ruleSubHandleLimitValue = _vm.formatNums(
                                                    subRuleAttr.ruleSubHandleLimitValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.ruleSubHandleLimitValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "ruleSubHandleLimitValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.ruleSubHandleLimitValue"
                                              }
                                            }),
                                            _c("span", [
                                              _vm._v("人数，每日关注上限")
                                            ]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.pointsGrantLimitValue = _vm.formatNums(
                                                    subRuleAttr.pointsGrantLimitValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.pointsGrantLimitValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "pointsGrantLimitValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.pointsGrantLimitValue"
                                              }
                                            }),
                                            _c("span", [_vm._v("积分")])
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "pad10-t" },
                            [
                              _c("span", [_vm._v("点赞帖子")]),
                              _c("span", { staticClass: "f12 gray9 mar30_l" }, [
                                _vm._v(
                                  "点赞者对单一帖子不论点赞多少次，积分只能领取一次"
                                )
                              ]),
                              _vm._l(_vm.ruleDtl.subRuleAttrList, function(
                                subRuleAttr
                              ) {
                                return _c(
                                  "div",
                                  { key: subRuleAttr.ruleSubType },
                                  [
                                    subRuleAttr.ruleSubType === "DZ_BY_OPERATOR"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "pad10-t pad20-l gray3"
                                          },
                                          [
                                            _c("span", [_vm._v("发帖者获得")]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.pointsGrantValue = _vm.formatNums(
                                                    subRuleAttr.pointsGrantValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.pointsGrantValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "pointsGrantValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.pointsGrantValue"
                                              }
                                            }),
                                            _c("span", [
                                              _vm._v("积分，每日奖励上限")
                                            ]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.ruleSubHandleLimitValue = _vm.formatNums(
                                                    subRuleAttr.ruleSubHandleLimitValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.ruleSubHandleLimitValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "ruleSubHandleLimitValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.ruleSubHandleLimitValue"
                                              }
                                            }),
                                            _c("span", [
                                              _vm._v("条数，每日奖励上限")
                                            ]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.pointsGrantLimitValue = _vm.formatNums(
                                                    subRuleAttr.pointsGrantLimitValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.pointsGrantLimitValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "pointsGrantLimitValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.pointsGrantLimitValue"
                                              }
                                            }),
                                            _c("span", [_vm._v("积分")])
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    subRuleAttr.ruleSubType === "DZ_OPERATOR"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "pad10-t pad20-l gray3"
                                          },
                                          [
                                            _c("span", [_vm._v("点赞者获得")]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.pointsGrantValue = _vm.formatNums(
                                                    subRuleAttr.pointsGrantValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.pointsGrantValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "pointsGrantValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.pointsGrantValue"
                                              }
                                            }),
                                            _c("span", [
                                              _vm._v("积分，每日奖励上限")
                                            ]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.ruleSubHandleLimitValue = _vm.formatNums(
                                                    subRuleAttr.ruleSubHandleLimitValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.ruleSubHandleLimitValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "ruleSubHandleLimitValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.ruleSubHandleLimitValue"
                                              }
                                            }),
                                            _c("span", [
                                              _vm._v("条数，每日奖励上限")
                                            ]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.pointsGrantLimitValue = _vm.formatNums(
                                                    subRuleAttr.pointsGrantLimitValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.pointsGrantLimitValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "pointsGrantLimitValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.pointsGrantLimitValue"
                                              }
                                            }),
                                            _c("span", [_vm._v("积分")])
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "pad10-t" },
                            [
                              _c("span", [_vm._v("评论帖子")]),
                              _c("span", { staticClass: "f12 gray9 mar30_l" }, [
                                _vm._v(
                                  "评论者对单一帖子不论评论多少次，积分只能领取一次"
                                )
                              ]),
                              _vm._l(_vm.ruleDtl.subRuleAttrList, function(
                                subRuleAttr
                              ) {
                                return _c(
                                  "div",
                                  { key: subRuleAttr.ruleSubType },
                                  [
                                    subRuleAttr.ruleSubType === "PL_BY_OPERATOR"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "pad10-t pad20-l gray3"
                                          },
                                          [
                                            _c("span", [_vm._v("发帖者获得")]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.pointsGrantValue = _vm.formatNums(
                                                    subRuleAttr.pointsGrantValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.pointsGrantValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "pointsGrantValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.pointsGrantValue"
                                              }
                                            }),
                                            _c("span", [
                                              _vm._v("积分，每日奖励上限")
                                            ]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.ruleSubHandleLimitValue = _vm.formatNums(
                                                    subRuleAttr.ruleSubHandleLimitValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.ruleSubHandleLimitValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "ruleSubHandleLimitValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.ruleSubHandleLimitValue"
                                              }
                                            }),
                                            _c("span", [
                                              _vm._v("条数，每日奖励上限")
                                            ]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.pointsGrantLimitValue = _vm.formatNums(
                                                    subRuleAttr.pointsGrantLimitValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.pointsGrantLimitValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "pointsGrantLimitValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.pointsGrantLimitValue"
                                              }
                                            }),
                                            _c("span", [_vm._v("积分")])
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    subRuleAttr.ruleSubType === "PL_OPERATOR"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "pad10-t pad20-l gray3"
                                          },
                                          [
                                            _c("span", [_vm._v("评论者获得")]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.pointsGrantValue = _vm.formatNums(
                                                    subRuleAttr.pointsGrantValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.pointsGrantValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "pointsGrantValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.pointsGrantValue"
                                              }
                                            }),
                                            _c("span", [
                                              _vm._v("积分，每日奖励上限")
                                            ]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.ruleSubHandleLimitValue = _vm.formatNums(
                                                    subRuleAttr.ruleSubHandleLimitValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.ruleSubHandleLimitValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "ruleSubHandleLimitValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.ruleSubHandleLimitValue"
                                              }
                                            }),
                                            _c("span", [
                                              _vm._v("条数，每日奖励上限")
                                            ]),
                                            _c("el-input", {
                                              on: {
                                                input: function($event) {
                                                  subRuleAttr.pointsGrantLimitValue = _vm.formatNums(
                                                    subRuleAttr.pointsGrantLimitValue,
                                                    true
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  subRuleAttr.pointsGrantLimitValue,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    subRuleAttr,
                                                    "pointsGrantLimitValue",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "subRuleAttr.pointsGrantLimitValue"
                                              }
                                            }),
                                            _c("span", [_vm._v("积分")])
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "box30" }),
      !_vm.ruleDtl.id
        ? _c(
            "div",
            { staticClass: "t_center" },
            [
              _c(
                "el-button",
                {
                  staticClass: "mar20_r",
                  on: {
                    click: function($event) {
                      return _vm.cancelRuleDtl()
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.saveRuleDtl()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "t_center" },
            [
              _c(
                "el-button",
                {
                  staticClass: "mar20_r",
                  on: {
                    click: function($event) {
                      return _vm.cancelRuleDtl()
                    }
                  }
                },
                [_vm._v("返 回")]
              )
            ],
            1
          ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            visible: _vm.chooseGoodVisible,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.chooseGoodVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "pad20_b" },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入商品名称" },
                    model: {
                      value: _vm.searchGoods.name,
                      callback: function($$v) {
                        _vm.$set(_vm.searchGoods, "name", $$v)
                      },
                      expression: "searchGoods.name"
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.goodSearch }
                    },
                    [_vm._v("搜 索")]
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.goodsDataList,
                    "row-key": "goodsId",
                    height: "289"
                  },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      "reserve-selection": true,
                      width: "55"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "商品名称", width: "400" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "marketPriceStr",
                      width: "200",
                      label: "价格"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "statusName", label: "状态" }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "box15" }),
              _c(
                "div",
                { staticClass: "t_right" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage,
                      "page-sizes": [10, 20, 50],
                      "page-size": _vm.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.totalCount,
                      "popper-class": "seller-style"
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.chooseGoodVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goodsDialogConfirm }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择客户",
            visible: _vm.customerPop.chooseClientVisible,
            "close-on-click-modal": false,
            width: "800px",
            "show-close": false,
            "custom-class": "chooseClientPop"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.customerPop, "chooseClientVisible", $event)
            }
          }
        },
        [
          _c("div", [
            _c("div", { staticClass: "clear ps_search_wrap" }, [
              _c(
                "span",
                {
                  staticClass: "float-left pad15_r lin_30 inlineblock",
                  staticStyle: { "padding-right": "25px" }
                },
                [_vm._v("客户名称")]
              ),
              _c(
                "div",
                { staticClass: "ps_search float-left" },
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "请输入客户名称" },
                    model: {
                      value: _vm.customerPop.searchCustomer.name,
                      callback: function($$v) {
                        _vm.$set(_vm.customerPop.searchCustomer, "name", $$v)
                      },
                      expression: "customerPop.searchCustomer.name"
                    }
                  })
                ],
                1
              )
            ]),
            _c(
              "div",
              {
                staticClass: "clear ps_search_wrap",
                staticStyle: { "padding-top": "10px" }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "float-left pad15_r lin_30 inlineblock",
                    staticStyle: { "padding-right": "11px" }
                  },
                  [_vm._v("客户手机号")]
                ),
                _c(
                  "div",
                  { staticClass: "ps_search float-left" },
                  [
                    _c("el-input", {
                      attrs: { type: "text", placeholder: "请输入客户手机号" },
                      model: {
                        value: _vm.customerPop.searchCustomer.phone,
                        callback: function($$v) {
                          _vm.$set(_vm.customerPop.searchCustomer, "phone", $$v)
                        },
                        expression: "customerPop.searchCustomer.phone"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "float-left client_pop_query",
                    on: {
                      click: function($event) {
                        return _vm.listCustomer(1)
                      }
                    }
                  },
                  [_vm._v("搜索")]
                )
              ]
            ),
            _c("div", { staticClass: "box30" }),
            _c("div", { staticClass: "clear ps_search_wrap" }, [
              _c(
                "span",
                { staticClass: "float-left pad15_r lin_30 inlineblock" },
                [_vm._v("客户分组")]
              ),
              _c(
                "div",
                { staticClass: "ps_search float-left" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        "popper-class": "seller-style",
                        placeholder: "请选择客户分组",
                        clearable: ""
                      },
                      model: {
                        value: _vm.customerPop.searchCustomer.groupId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.customerPop.searchCustomer,
                            "groupId",
                            $$v
                          )
                        },
                        expression: "customerPop.searchCustomer.groupId"
                      }
                    },
                    _vm._l(_vm.customerPop.groupDataList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "box20" }),
            _c("div", { staticClass: "clear ps_group_list" }, [
              _c("div", { staticClass: "float-left client_list_all" }, [
                _c("p", [_vm._v("我的客户")]),
                _c("div", { staticClass: "client_list_pop_main" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.customerPop.customerDataList, function(
                      item,
                      index
                    ) {
                      return _c(
                        "li",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.customerDialogSelect(item)
                            }
                          }
                        },
                        [
                          item.isCheck
                            ? _c("div", {
                                staticClass: "client_list_mask",
                                domProps: {
                                  innerHTML: _vm._s(
                                    "归属合同模板：" + item.attrName
                                  )
                                }
                              })
                            : _vm._e(),
                          _c(
                            "p",
                            { staticClass: "group_item_name ellipsis_two" },
                            [_vm._v(_vm._s(item.name))]
                          ),
                          _c("p", [
                            _vm._v(
                              "身份：" +
                                _vm._s(item.targetType === 1 ? "个人" : "企业")
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]),
              _c("div", { staticClass: "float-right client_list_me" }, [
                _c("p", [_vm._v("已选客户")]),
                _c("div", { staticClass: "client_list_pop_main" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.customerPop.customerSelList, function(
                      item,
                      index
                    ) {
                      return _c("li", { key: index }, [
                        _c("i", {
                          staticClass: "iconfont icon-shibai fb",
                          on: {
                            click: function($event) {
                              return _vm.removeSelectCustomer(item)
                            }
                          }
                        }),
                        _c(
                          "p",
                          { staticClass: "group_item_name ellipsis_two" },
                          [_vm._v(_vm._s(item.name))]
                        ),
                        _c("p", [
                          _vm._v(
                            "身份：" +
                              _vm._s(item.targetType === 1 ? "个人" : "企业")
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "box20" }),
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.customerPop.currentPageCustomer,
              "page-sizes": [10, 20, 30],
              "page-size": _vm.customerPop.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.customerPop.totalCount,
              "popper-class": "seller-style"
            },
            on: {
              "size-change": _vm.handleSizeChangeCustomer,
              "current-change": _vm.handleCurrentChangeCustomer
            }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.customerDialogConfirm }
                },
                [_vm._v("确 认")]
              ),
              _c("el-button", { on: { click: _vm.customerDialogClose } }, [
                _vm._v("取 消")
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }